import React from 'react';

import type { Language } from '@bringg/types';
import { Tabs } from '@bringg/react-components';
import { AddLanguageDropDown, TabTitle } from '@bringg-frontend/add-language';

import styles from './languages-control.module.scss';

interface LanguagesControlProps {
	activeLanguageCode: string;
	defaultLanguageCode: string;
	activeLanguages: Language[];
	availableLanguagesToAdd: Language[];
	setActiveLanguageCode: (languageCode: string) => void;
	onAddLanguage: (language: Language) => void;
	onRemoveLanguage: (languageCode: string) => void;
}

const LanguagesControl: React.FC<LanguagesControlProps> = ({
	activeLanguageCode,
	defaultLanguageCode,
	activeLanguages,
	availableLanguagesToAdd,
	setActiveLanguageCode,
	onAddLanguage,
	onRemoveLanguage
}) => {
	return (
		<div className={styles.languages}>
			<Tabs
				activeKey={activeLanguageCode}
				defaultActiveKey={defaultLanguageCode}
				className={styles.languageTabs}
				tabBarGutter={0}
				tabBarExtraContent={
					availableLanguagesToAdd.length > 0
						? {
								left: (
									<AddLanguageDropDown
										languages={availableLanguagesToAdd}
										onSelect={onAddLanguage}
										data-test-id="column-labels-add-language"
									/>
								)
						  }
						: null
				}
				onChange={setActiveLanguageCode}
				items={activeLanguages.map(lang => ({
					key: lang.code,
					label: (
						<span data-test-id={`column-labels-language-${lang.code}`}>
							<TabTitle
								language={lang}
								onRemove={() => onRemoveLanguage(lang.code)}
								isRemovable={lang.code !== defaultLanguageCode}
								data-test-id={`column-labels-remove-language-${lang.code}`}
							/>
						</span>
					),
					children: null
				}))}
			/>
		</div>
	);
};

export default LanguagesControl;
